export default __webpack_public_path__ + "static/media/brgPopupWin.f3ad6972.png";